import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { DataBagService } from 'src/app/common/data-bag.service';
import { ServiceService } from '../../service.service';
import { Multimedia } from '../../service.model';

@Component({
	selector: 'app-service-multimedia',
	templateUrl: './service-multimedia.component.html',
	styleUrls: ['./service-multimedia.component.scss'],
})
export class ServiceMultimediaComponent {
	@ViewChild('dataTable') table: MatTable<any>;

	photo = '';
	displayedColumns: string[] = [`url`, 'link', `edit`];

	constructor(
		public service: ServiceService,
		private readonly bag: DataBagService,
	) {}
	dropTable(event: CdkDragDrop<any>): void {
		moveItemInArray(this.service.data.serviceMultimedias, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	uploadFile(event) {
		const oldLength = this.service.data.serviceMultimedias.length;
		for (let i = 0; i < event.target.files.length; i++) {
			this.bag.upload('/multimedia/file/', event.target.files[i], (result, error) => {
				this.photo = result.url;
				this.service.data.serviceMultimedias.push({
					id: null,
					multimedia: result,
					order: oldLength + i + 1,
				});
				this.table.renderRows();
			});
		}
	}

	deleteImage(index) {
		this.service.data.serviceMultimedias.splice(this.service.data.serviceMultimedias.indexOf(index), 1);
		this.table.renderRows();
	}
}
